import { render, staticRenderFns } from "./InvalidationPointSearch.vue?vue&type=template&id=b620ef6e&scoped=true"
import script from "./InvalidationPointSearch.vue?vue&type=script&lang=js"
export * from "./InvalidationPointSearch.vue?vue&type=script&lang=js"
import style0 from "./InvalidationPointSearch.vue?vue&type=style&index=0&id=b620ef6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b620ef6e",
  null
  
)

export default component.exports